import { ViewModel } from '../../view-model';
import { CONFIG } from '../../../core/config';
import { RiskMatrixBand } from './risk-matrix-band';

export class RiskMatrixCell implements ViewModel {
  readonly friendlyTypeNameSingular = 'Risk Matrix Cell';
  readonly apiRoute: string = CONFIG.apiRoutes.riskMatrixCells;

  riskMatrixCellId: string;
  riskMatrixProbabilityVectorId: string;
  riskMatrixConsequenceVectorId: string;
  columnIndex: number;
  label: string;
  riskBand: RiskMatrixBand = new RiskMatrixBand();

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.riskMatrixCellId = data.riskMatrixCellId;
    this.riskMatrixProbabilityVectorId = data.riskMatrixProbabilityVectorId;
    this.riskMatrixConsequenceVectorId = data.riskMatrixConsequenceVectorId;
    this.columnIndex = data.columnIndex;
    this.label = data.label;

    if (data.riskBand) {
      this.riskBand = new RiskMatrixBand();
      this.riskBand.loadFromJson(data.riskBand);
    }
  }
}
